export const footer_column_1 = ["Caretakers", "About"];
export const footer_column_2 = ["Contact", "New York"];
export const footer_column_3 = ["Newsletter", "Blog"];
